declare var require;

export class AnimationContents {
    //public static INTRO_SCREEN_JSON = require("../../../animate/IntroScreen.json");
    public static PRELOADER_SCREEN_JSON = require("../../../animate/PreloaderScreen.json");
    public static GAME_SCREEN_JSON = require("../../../animate/GameScreen.json");
    public static MAIN_SCREEN_JSON = require("../../../animate/MainScreen.json");
    //public static SETTINGS_SCREEN_JSON = require("../../../animate/SettingsScreen.json");
    //public static OUTFIT_SCREEN_JSON = require("../../../animate/OutfitScreen.json");
    public static UI_SCREEN_JSON = require("../../../animate/UIScreen.json");
    public static PAUSE_SCREEN_JSON = require("../../../animate/PauseScreen.json");
    //public static GAMEOVER_MODAL = require("../../../animate/GameEnd.json");
    //public static EXIT_MODAL_JSON = require("../../../animate/ExitGameScreen.json");
    public static ERROR_MODAL_JSON = require("../../../animate/ErrorScreen.json");
    //public static PRIZES_MODAL_JSON = require("../../../animate/PrizesScreen.json");
    //public static MY_PRIZE_MODAL_JSON = require("../../../animate/MyPrizeScreen.json");
    //public static MY_PRIZES_MODAL_JSON = require("../../../animate/MyPrizesScreen.json");
    // public static PROMOCODES_MODAL_JSON = require("../../../animate/GetPrizesScreen.json");
    // public static PROMOCODES_LIST_MODAL_JSON = require("../../../animate/PromocodesListScreen.json");
    public static LEADER_BOARD_MODAL_JSON = require("../../../animate/LeaderBoardScreen.json");
    public static FULLSCREEN_JSON = require("../../../animate/Fullscreen.json");
    public static ENTER_NAME_JSON = require("../../../animate/EnterNameScreen.json");
    public static CHARACTER_DIALOG_JSON = require('../../../animate/CharactersDialogScreen.json');
    public static TUTORIAL_JSON = require('../../../animate/TutorialScreen.json');
}
